// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"914b65d6","309":"831f5b1d"}[chunkId] + ".chunk.css";
};